import { useEffect } from "react";

export const useLinks = (links = []) => {
	useEffect(() => {
		// avoid injecting links multiple times inside iframes
		if (!links.length || typeof document === "undefined" || window.self !== window.top) return;

		const fragment = document.createDocumentFragment();

		links.forEach(({ rel, href, as, type, crossOrigin, fetchPriority }) => {
			if (!rel || !href || document.querySelector(`link[rel="${rel}"][href="${href}"]`)) {
				return
			};

			const link = document.createElement("link");
			link.rel = rel;
			link.href = href;
			if (as) link.as = as;
			if (type) link.type = type;
			if (crossOrigin) link.crossOrigin = crossOrigin;
			if (fetchPriority) link.fetchPriority = fetchPriority;

			fragment.appendChild(link);
		});

		if (fragment.childNodes.length) {
			document.head.appendChild(fragment);
		}
	}, [links]);
};
